"use strict";

/* eslint-disable no-param-reassign */
var _ = require('lodash');
module.exports = /*@ngInject*/function () {
  return function (values, term, fields) {
    term = (term || '').replace(/[.?*+^$,[\]\\(){}#|-]/g, '\\$&').split(' ');
    values = values || [];
    fields = fields || [];
    if (fields.length) {
      return values.filter(function (value) {
        return _.every(term, function (t) {
          return _.some(fields, function (field) {
            return value[field] && value[field].match(new RegExp(t, 'i'));
          });
        });
      });
    }
    return values.filter(function (value) {
      return _.every(term, function (t) {
        return value.match(new RegExp(t, 'i'));
      });
    });
  };
};